export const enum AppRoutes {
    LandingPage = '/',
    SettingsPage = '/settings',
    HomePage = '/home',
    LogoutPage = '/logout',
    CookiesPage = '/cookies',
    TandC = '/tandc',
    PrivacyPage = '/privacy',
    ContactPage = '/contact',
    AccessibilityStatement = '/accessibility',
    Unauthorized = '/403',
    Management = '/admin/management',
    Tenant = '/admin/management/tenant',
    FixedAsset = '/fixedasset/:id',
    ProjectData = '/project-data/:id',
    TaxPools = '/tax-pools/',
    Rules = '/rules/',
    Reporting = '/reporting',
    Log = '/log',
}

export const LoginRedirectStorageKey = 'returnRoute';

/// Mirrors the backend DataSourceTypeId enum; the grid and columns endpoints require it.
export const enum DataSourceTypeId {
    FixedAsset = 1,
    Project = 2,
}

/// Mirrors the backend ImportMode enum, which orval emits as NUMBER_1 / NUMBER_2.
export const enum ImportMode {
    Append = 1,
    Replace = 2,
}

/// Project grids use 0 to mean every project in the entity and period.
export const AllProjectsId = 0;
